import {
  ActivityIcon,
  BarChart3Icon,
  BookOpenIcon,
  BrainIcon,
  ClipboardListIcon,
  ClockIcon,
  FlaskConicalIcon,
  HeartPulseIcon,
  PenLineIcon,
  WindIcon,
  type LucideIcon,
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  activity: ActivityIcon,
  chart: BarChart3Icon,
  book: BookOpenIcon,
  brain: BrainIcon,
  list: ClipboardListIcon,
  clock: ClockIcon,
  flask: FlaskConicalIcon,
  heart: HeartPulseIcon,
  pen: PenLineIcon,
  lungs: WindIcon,
};

export function getIcon(key: string): LucideIcon {
  return iconMap[key] ?? BookOpenIcon;
}
